"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a11yErrorId = void 0;
var a11yErrorId = exports.a11yErrorId = function a11yErrorId(name) {
  return "a11y_error_".concat(name);
};